<template>
  <v-dialog
    v-model="computedLiftopsliftopsdesignatedroutesCatskinnerVisibility"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card>
        <!-- close icon -->
        <v-btn
          icon
          @click="
            methodToggleSingleLayer(
              'liftopsdesignatedroutes',
              'catskinner',
              false
            )
          "
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <span>{{ computedCatskinnerName }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          v-if="
            computedAuthDept == 'admin' ||
              computedAuthDept == 'manager' ||
              computedAuthRole === 'maintenance'
          "
          icon
          @click="disable_edit = !disable_edit"
          :class="!disable_edit ? 'primary' : null"
        >
          <v-icon>edit</v-icon>
        </v-btn>
      </v-toolbar>
      <div
        style="background-color: black; padding-left: 30px; overflow:auto; -webkit-overflow-scrolling:touch;"
      >
        <v-data-table
          :items="
            computedLiftopsliftopsdesignatedroutesCatskinnerGeoJsonFeature
          "
          :loading="computedLiftopsliftopsdesignatedroutesCatskinnerLoading"
          :hide-actions="hideactions"
          :hide-headers="hideheaders"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>Mountain</td>
              <td>{{ props.item.properties.mountain }}</td>
            </tr>
            <tr>
              <td>Description</td>
              <td>{{ props.item.properties.label }}</td>
            </tr>
            <tr>
              <td>Direction of travel</td>
              <td>{{ props.item.properties.dir_travel }}</td>
            </tr>
            <tr>
              <td>Route Information</td>
              <td>
                <v-textarea
                  ref="notes"
                  v-model="props.item.properties.notes"
                  :disabled="disable_edit"
                ></v-textarea>
              </td>
            </tr>
            <tr>
              <td>
                <v-btn
                  @click="
                    methodEditNotes({
                      notes: $refs.notes.value
                    });
                    disable_edit = true;
                    methodToggleSingleLayer(
                      'liftopsdesignatedroutes',
                      'catskinner',
                      false
                    );
                  "
                  :disabled="disable_edit"
                  class="success"
                  >Save</v-btn
                >
              </td>
              <td></td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>

<style scoped>
table {
  padding-top: 20px;
}
</style>
<script>
export default {
  data() {
    return {
      disable_edit: true,
      loading: true,
      persistent: false,
      hideheaders: true,
      hideactions: true,
      solo: true
    };
  },
  computed: {
    computedCatskinnerName() {
      if (this.computedLiftopsliftopsdesignatedroutesCatskinnerVisibility) {
        const catskinner = this.$store.state.mapLayers.liftopsdesignatedroutes
          .layers.catskinner.geojson.features;
        // grabs the label of the currently viewed ID
        let result = catskinner.filter(
          item =>
            item.properties.id ==
            this.computedLiftopsliftopsdesignatedroutesCatskinnerId
        );
        return result[0].properties.label;
      }
      return [];
    },
    computedLiftopsliftopsdesignatedroutesCatskinnerGeoJsonFeature() {
      if (
        this.$store.state.mapLayers.liftopsdesignatedroutes.layers.catskinner
          .geojson.features
      ) {
        const catskinner = this.$store.state.mapLayers.liftopsdesignatedroutes
          .layers.catskinner.geojson.features;
        const result = catskinner.filter(
          item =>
            item.properties.id ==
            this.computedLiftopsliftopsdesignatedroutesCatskinnerId
        );
        return result;
      }
      return [];
    },
    computedLiftopsliftopsdesignatedroutesCatskinnerVisibility() {
      return this.$store.state.mapLayers.liftopsdesignatedroutes.layers
        .catskinner.visibility.singleView;
    },
    computedLiftopsliftopsdesignatedroutesCatskinnerLoading() {
      return this.$store.state.mapLayers.liftopsdesignatedroutes.layers
        .catskinner.loading;
    },
    computedLiftopsliftopsdesignatedroutesCatskinnerId() {
      return this.$store.state.mapLayers.liftopsdesignatedroutes.layers
        .catskinner.visibility.singleId;
    },
    computedAuth() {
      return this.$store.state.auth;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    // method to get geojson
    methodGetLiftopsliftopsdesignatedroutesCatskinnerGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/liftopsdesignatedroutes/catskinner",
        dept: "liftopsdesignatedroutes",
        layer: "catskinner",
        token: this.computedAuthToken
      });
    },
    methodEditNotes(data) {
      this.$store
        .dispatch("actionEditGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/liftops/designatedroutes/" +
            this.computedLiftopsliftopsdesignatedroutesCatskinnerId,
          dept: "liftopsdesignatedroutes",
          layer: "catskinner",
          token: this.computedAuthToken,
          payload: data
        })
        .then(this.methodGetLiftopsliftopsdesignatedroutesCatskinnerGeoJson());
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.liftopsdesignatedroutes.layers.catskinner.visibility.singleView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetLiftopsliftopsdesignatedroutesCatskinnerGeoJson();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.liftopsdesignatedroutes.layers.catskinner.geojson": function(
      newValue
    ) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
